'use client';

import React from 'react';
import { Box, Tab as MuiTab, Tabs as MuiTabs } from '@unity/cloud-ui';

interface TabProps {
  title: string;
  children: React.ReactNode;
}

export const Tab = (_: TabProps) => null;

export const Tabs = (props: React.PropsWithChildren) => {
  const { children } = props;
  const [tabIndex, setTabIndex] = React.useState(0);

  const tabTitles =
    React.Children.map(props.children, (child) => {
      if (React.isValidElement<TabProps>(child)) {
        return child.props.title;
      }
      return null;
    })?.filter(Boolean) || [];

  const tabChildren =
    React.Children.map(children, (child) => {
      if (React.isValidElement<TabProps>(child)) {
        return child.props.children;
      }
      return null;
    })?.filter(Boolean) || [];

  const handleTabChange = (_: React.SyntheticEvent, newValue: number) => {
    setTabIndex(newValue);
  };

  return (
    <>
      <MuiTabs
        value={tabIndex}
        onChange={handleTabChange}
        sx={({ palette }) => ({ borderBottom: `1px solid ${palette.divider}` })}
      >
        {tabTitles.map((title, index) => {
          return <MuiTab label={title} key={index} />;
        })}
      </MuiTabs>
      <Box marginX={2} marginBottom={3}>
        {tabChildren[tabIndex]}
      </Box>
    </>
  );
};

export default Tabs;
